import PropTypes from 'prop-types'
import { availableRdtRuleRegulationPropType } from './available-rdt-rule-regulation-prop-type'

/**
 * @typedef {Object} AvailableRdtRule
 * @property {string} [country]                             - Country ISO code (2-characters, uppercase).
 * @property {AvailableRdtRuleRegulation[]} [regulations]   - Possible RDT regulations to calculate driving/working
 *                                                            times.
 */
export const availableRdtRulePropType = PropTypes.shape({
    country: PropTypes.string,
    regulations: PropTypes.arrayOf(availableRdtRuleRegulationPropType)
})
